import { PassengerConfirmTripUpdateInput, TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useMutation } from '@tanstack/react-query';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

type Input = PassengerConfirmTripUpdateInput & { key: string; jwtToken: string };

const anonymousConfirmUpdate = ({ key, jwtToken, ...input }: Input) =>
  passengerApi.post<PassengerConfirmTripUpdateInput, TripOutput>(`anonymous/v1/${key}/confirm-update`, input, {
    headers: { Authorization: `Bearer ${jwtToken}` },
  });

export const useAnonymousConfirmUpdate = (jwtToken: string) => {
  const anonymousConfirmUpdateMutation = useMutation<TripOutput, APIError, Input>({
    mutationKey: mutationKeys.anonymousConfirmUpdateTrip(jwtToken),
    mutationFn: anonymousConfirmUpdate,
    onSuccess: trip => {
      queryClient.setQueryData(queryKeys.fetchAnonymousTrip(jwtToken), trip);
    },
  });

  return anonymousConfirmUpdateMutation;
};
